import { configureStore } from '@reduxjs/toolkit';
import profesorReducer from './reducersV2/profesorSlice';
import estudianteReducer from './reducersV2/estudianteSlice';
import authReducer from './reducersV2/authSlice';
import uiReducer from './reducersV2/uiSlice';
import blockMovementReducer from './reducersV2/blockMovementSlice';
import actividadCreadaStateReducer from './reducersV2/actividadCreadaStateSlice';
import evaluacionVisibleStateReducer from './reducersV2/evaluacionVisibleStateSlice';
import explicacionHabilidadesModalReducer from './reducersV2/explicacionHabilidadesModalStateSlice';
import rubricaCreadaStateReducer from './reducersV2/rubricaCreadaStateSlice';
import idiomaRutaReducer from './reducersV2/idiomaRutaSlice';
import undraggableCardsReducer from './reducersV2/undraggableCardsSlice';
import currentActividadStateReducer from './reducersV2/currentActividadStateSlice';
import currentActividadRubricaStateReducer from './reducersV2/currentActividadRubricaStateSlice';
import currentRutasTabReducer from './reducersV2/currentRutasTabStateSlice';
import dirtyAsignaturasReducer from './reducersV2/dirtyAsignaturasStateSlice';
import avatarEstudianteReducer from './reducersV2/avatarEstudianteSlice';
import vistaBloquesReducer from './reducersV2/vistaBloquesStateSlice';
import currentVistaPresentacinReducer from './reducersV2/currentVistaPresentacionSlice';
import guiaDigitalBloquesIsDirtyReducer from './reducersV2/guiaDigitalBloquesIsDirtyStateSlice';
import isEditingEvaluacionesReducer from './reducersV2/isEditingEvaluacionesStateSlice';
import isEditingEvaluacionesModalOpenReducer from './reducersV2/isEditingEvaluacionesModalOpenStateSlice';
import errorStateReducer from './reducersV2/errorStateSlice';
import currentDesafioCursoReducer from './reducersV2/currentDesafioCursoStateSlice';
import currentRutaEtapaEvaluacionReducer from './reducersV2/currentRutaEtapaEvaluacionSlice';
import isTopMenuCollapsedReducer from './reducersV2/isTopMenuCollapsedStateSlice';
import proyectoFavoritoReducer from './reducersV2/proyectoFavoritoStateSlice';
import currentDesafioSelectedEstudianteReducer from './reducersV2/currentDesafioSelectedEstudianteSlice';
import langCountryUserReducer from './reducersV2/langCountryUserSlice';
import tablaRubricaStatusReducer from './reducersV2/tablaRubricaStatusSlice';
import respuestaBloquesReducer from './reducersV2/respuestasBloquesSlice';
import cursoProfesorDesafioReducer from './reducersV2/cursoProfesorDesafioStateSlice';
import desafioFinalizadoReducer from './reducersV2/desafioFinalizadoStateSlice';
import displayEvidenciaSegReducer from './reducersV2/displayEvidenciaSegSlice';
import displayGuiaSegReducer from './reducersV2/displayGuiaSegSlice';
import displayRubricaSegReducer from './reducersV2/displayRubricaSegSlice';
import infoSesionReducer from './reducersV2/infoSesionStateSlice';
import listaStudentReducer from './reducersV2/listaStudentStateSlice';
import modalPlanificacionReducer from './reducersV2/modalPlanificacionSlice';
import rutaSesionesAsignaturasCachedReducer from './reducersV2/rutaSesionesAsignaturasCachedStateSlice';
import isEstudianteUpdatedReducer from './reducersV2/isEstudianteUpdatedStateSlice';
import datosBaseProfesorReducer from './reducersV2/datosBaseProfesorStateSlice';
import datosBaseEstudianteReducer from './reducersV2/datosBaseEstudianteStateSlice';
import tabRouterReducer from './reducersV2/tabRouterStateSlice';
import sesionSelectorSharedLocalReducer from './reducersV2/sesionSelectorSharedLocalStateSlice';
import rutaSesionesCachedReducer from './reducersV2/rutaSesionesCachedStateSlice';
import postGroupCreationReducer from './reducersV2/postGroupCreationStateSlice';
import currentSesionReducer from './reducersV2/currentSesionStateSlice';
import selectedSesionReducer from './reducersV2/selectedSesionStateSlice';
import currentTipoActividadReducer from './reducersV2/currentTipoActividadStateSlice';
import guiaDisponibleNoEnviadaReducer from './reducersV2/guiaDisponibleNoEnviadaStateSlice';
import visualGenericaEstudianteReducer from './reducersV2/IsVisualGenericaEstudianteStateSlice';
import guiasDigitalesReducer from './reducersV2/guiasDigitalesStateSlice';
import isReadOnlyReducer from './reducersV2/isReadOnlyStateSlice';
import hasActividadesGrupalesReducer from './reducersV2/hasActividadesGrupalesStateSlice';
import isSideBarContractedReducer from './reducersV2/isSideBarContractedStateSlice';
import evaluacionesStateReducer from './reducersV2/evaluacionesStateSlice';
import currentEvaluacionReducer from './reducersV2/currentEvaluacionStateSlice';
import selectedEstudianteReducer from './reducersV2/selectedEstudianteStateSlice';
import isOriginalEvaluacionEditedReducer from './reducersV2/isOriginalEvaluacionEditedStateSlice';
import isPreguntasModalDisplayedReducer from './reducersV2/isPreguntasModalDisplayedStateSlice';
import isEvaluacionesModalDisplayedReducer from './reducersV2/isEvaluacionesModalDisplayedStateSlice';
import displayTextMenuReducer from './reducersV2/displayTextMenuSlice';
import mobileViewReducer from './reducersV2/mobileViewSlice';
import personalViewReducer from './reducersV2/personalViewSlice';
import editPassAvatarMobileReducer from './reducersV2/editPassAvatarMobileSlice';
import barraProgresoMobileReducer from './reducersV2/barraProgresoMobileSlice';
import plantillasModalReducer from './reducersV2/plantillasModalSlice';
import currentGrupoTemporalReducer from './reducersV2/currentGrupoTemporalSlice';
import ultimoMensajeLeidoReducer from './reducersV2/ultimoMensajeLeidoSlice';
import notificacionesReducer from './reducersV2/notificacionesSlice';
import fechasPlanificacionSesionReducer from './reducersV2/fechasPlanificacionSesionState';
import horaServidorStateReducer from './reducersV2/horaServidorStateSlice';
import tablaDimensionesReducer from './reducersV2/tablaDimensionesSlice';
import planificacionEditStateReducer from './reducersV2/planificacionEditStateSlice';
import rubricaDataStateReducer from './reducersV2/rubricaDataStateSlice';
import rubricaDataUpdateaReducer from './reducersV2/rubricaDataUpdateaSlice';
import tablaRubricaFilaStatusReducer from './reducersV2/tablaRubricaFilaStatusSlice';
import rubricaDataPuntajeStateReducer from './reducersV2/rubricaDataPuntajeStateSlice';
import asignaturasStatusReducer from './reducersV2/asignaturasStatusSlice';
import blockDataStateReducer from './reducersV2/blockDataStateSlice';
import objetivoDisplayStateReducer from './reducersV2/objetivoDisplayStateSlice';
import modalProgresionDesafioReducer from './reducersV2/modalProgresionDesafioState';
import numeroEvaluacionesSesionReducer from './reducersV2/numeroEvaluacionesSesionSlice';
// ver si es necesario el blockDragger y el blockDeleted en bloques
import blockDraggedReducer from './reducersV2/blockDraggedSlice';
import blockDeletedCacheReducer from './reducersV2/blockDeletedCacheSlice';
import planificacionDisplayDateReducer from './reducersV2/planificacionDisplayDateSlice';
import selectedCurrentViewActividadReducer from './reducersV2/selectedCurrentViewActividadSlice';
import datosBaseMonitorReducer from './reducersV2/datosBaseMonitorStateSlice';
// import bloquesDataStateReducer from './reducersV2/bloquesDataStateSlice';
import tablaMobileReducer from './reducersV2/tablaMobileSlice';
import asignaturaRutaDisplayReducer from './reducersV2/planificacionDisplayAsignaturasRuta';
import simbologiaRutaDisplayReducer from './reducersV2/planificacionDisplaySimbologiaRuta';
import rutaYearFilterReducer from './reducersV2/rutaYearFilterSlice';
import cursoYearFilterReducer from './reducersV2/cursoYearFilterSlice';
import selectedCurrentViewInstrumentoReducer from './reducersV2/selectedCurrentViewInstrumentoSlice';
import dusplayDesafioSegReducer from './reducersV2/displayDesafioSegSlice';
import displayDesafioSegCompromisoReducer from './reducersV2/displayDesafioCompromisoSegSlice';
import calendarioCursoReducer from './reducersV2/calendarioCursoSlice';
import registerUserReducer from './reducersV2/userRegistrationSlice';
import verComentarioGuiaReducer from './reducersV2/verComentarioGuiaSlice';
import rutaSesionKeyReducer from './reducersV2/rutaSesionKeySlice';
import calendarSelectedDateReducer from './reducersV2/calendarSelectedDateSlice';
import rubricaTotalesStateReducer from './reducersV2/rubricaTotalesSlice';

const planificacionRutaReducers = {
	actividadCreadaState: actividadCreadaStateReducer,
	evaluacionVisible: evaluacionVisibleStateReducer,
	explicacionHabilidadesModalState: explicacionHabilidadesModalReducer,
	rubricaCreadaState: rubricaCreadaStateReducer,
	idiomaRuta: idiomaRutaReducer,
	undraggableCards: undraggableCardsReducer,
	currentRutasTabState: currentRutasTabReducer,
	dirtyAsignaturaState: dirtyAsignaturasReducer,
	planificacionDisplayDateState: planificacionDisplayDateReducer,
	calendarSelectedDateState: calendarSelectedDateReducer
};

const habilidadesModalEstudiantePendientesReducers = {
	isEditingEvaluacionesState: isEditingEvaluacionesReducer,
	isEditingEvaluacionesModalOpenState: isEditingEvaluacionesModalOpenReducer
};

const rubricasReducers = {
	rubricaDataState: rubricaDataStateReducer,
	rubricaDataUpdatea: rubricaDataUpdateaReducer,
	tablaRubricaFilaStatus: tablaRubricaFilaStatusReducer,
	rubricaDataPuntajeState: rubricaDataPuntajeStateReducer,
	tablaRubricaStatus: tablaRubricaStatusReducer
};

const seguimientoReducers = {
	displayEvidenciaSeg: displayEvidenciaSegReducer,
	displayGuiaSeg: displayGuiaSegReducer,
	displayRubricaSeg: displayRubricaSegReducer,
	numeroEvaluacionesSesionState: numeroEvaluacionesSesionReducer,
	displayDesafioSegState: dusplayDesafioSegReducer,
	displayDesafioCompromisoSegState: displayDesafioSegCompromisoReducer
};

const blockReducers = {
	blockDataState: blockDataStateReducer,
	blockMovement: blockMovementReducer,
	blockDragged: blockDraggedReducer,
	blockDeletedCache: blockDeletedCacheReducer
};

const rootReducer = {
	auth: authReducer,
	profesor: profesorReducer,
	estudiante: estudianteReducer,
	ui: uiReducer,
	currentActividadState: currentActividadStateReducer,
	currentActividadRubricaState: currentActividadRubricaStateReducer,
	avatarEstudiante: avatarEstudianteReducer,
	vistaBloques: vistaBloquesReducer,
	currentVistaPresentacion: currentVistaPresentacinReducer,
	guiaDigitalBloquesIsdirtyState: guiaDigitalBloquesIsDirtyReducer,
	errorState: errorStateReducer,
	currentDesafioCurso: currentDesafioCursoReducer,
	currentRutaEtapaEvaluacion: currentRutaEtapaEvaluacionReducer,
	isTopMenuCollapsedState: isTopMenuCollapsedReducer,
	proyectoFavoritoState: proyectoFavoritoReducer,
	currentDesafioSelectedEstudiante: currentDesafioSelectedEstudianteReducer,
	langCountryUser: langCountryUserReducer,
	respuestaBloques: respuestaBloquesReducer,
	cursoProfesorDesafioState: cursoProfesorDesafioReducer,
	desafioFinalizadoState: desafioFinalizadoReducer,
	...seguimientoReducers,
	infoSesionState: infoSesionReducer,
	listaStudentState: listaStudentReducer,
	modalPlanificacion: modalPlanificacionReducer,
	rutaSesionesAsignaturasCachedState: rutaSesionesAsignaturasCachedReducer,
	isEstudianteUpdatedState: isEstudianteUpdatedReducer,
	datosBaseProfesorState: datosBaseProfesorReducer,
	datosBaseEstudianteState: datosBaseEstudianteReducer,
	datosBaseMonitorState: datosBaseMonitorReducer,
	tabRouterState: tabRouterReducer,
	sesionSelectorSharedLocalState: sesionSelectorSharedLocalReducer,
	rutaSesionesCachedState: rutaSesionesCachedReducer,
	postGroupCreationState: postGroupCreationReducer,
	currentSesionState: currentSesionReducer,
	selectedSesionState: selectedSesionReducer,
	currentTipoActividadState: currentTipoActividadReducer,
	guiaDisponibleNoEnviadaState: guiaDisponibleNoEnviadaReducer,
	isVisualGenericaEstudianteState: visualGenericaEstudianteReducer,
	guiasDigitalesState: guiasDigitalesReducer,
	isReadOnlyState: isReadOnlyReducer,
	hasActividadesGrupalesState: hasActividadesGrupalesReducer,
	isSideBarContractedState: isSideBarContractedReducer,
	evaluacionesState: evaluacionesStateReducer,
	currentEvaluacionState: currentEvaluacionReducer,
	selectedEstudianteState: selectedEstudianteReducer,
	isOriginalEvaluacionEditedState: isOriginalEvaluacionEditedReducer,
	isPreguntasModalDisplayedState: isPreguntasModalDisplayedReducer,
	isEvaluacionesModalDisplayedState: isEvaluacionesModalDisplayedReducer,
	displayTextMenu: displayTextMenuReducer,
	mobileView: mobileViewReducer,
	personalView: personalViewReducer,
	editPassAvatarMobile: editPassAvatarMobileReducer,
	barraProgresoMobile: barraProgresoMobileReducer,
	plantillasModal: plantillasModalReducer,
	currentGrupoTemporalState: currentGrupoTemporalReducer,
	ultimoMensajeLeidoState: ultimoMensajeLeidoReducer,
	notificaciones: notificacionesReducer,
	fechasPlanificacionSesion: fechasPlanificacionSesionReducer,
	horaServidorState: horaServidorStateReducer,
	tablaDimensiones: tablaDimensionesReducer,
	planificacionEditState: planificacionEditStateReducer,
	asignaturasStatus: asignaturasStatusReducer,
	objetivoDisplayState: objetivoDisplayStateReducer,
	modalProgresionDesafio: modalProgresionDesafioReducer,
	selectedCurrentViewActividadState: selectedCurrentViewActividadReducer,
	...blockReducers,
	...rubricasReducers,
	// bloquesDataState: bloquesDataStateReducer,
	...habilidadesModalEstudiantePendientesReducers,
	...planificacionRutaReducers,
	tablaMobileState: tablaMobileReducer,
	asignaturaRutaDisplayState: asignaturaRutaDisplayReducer,
	simbologiaRutaDisplayState: simbologiaRutaDisplayReducer,
	rutaYearFilterState: rutaYearFilterReducer,
	cursoYearFilterState: cursoYearFilterReducer,
	selectedCurrentViewInstrumentoState: selectedCurrentViewInstrumentoReducer,
	calendarioCursoState: calendarioCursoReducer,
	registerUser: registerUserReducer,
	verComentarioGuia: verComentarioGuiaReducer,
	rutaSesionKey: rutaSesionKeyReducer,
	rubricaTotalesState: rubricaTotalesStateReducer
};

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: true })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
